import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { BrockenImageSize, GameSettingsService, ImageType } from 'src/app/core/firebase/gameSettings.service';
import { ChatUserInfoDispatcher } from 'src/app/core/state/chatUserInfo/chatUserInfo.dispatcher';
import { IChatUserInfoData } from 'src/app/core/state/chatUserInfo/chatUserInfo.state';
import { ClubMessage } from 'src/app/core/state/club/club.state';

@Component({
    selector: 'app-message-bubble',
    templateUrl: './message-bubble.component.html',
    styleUrls: ['./message-bubble.component.scss'],
    standalone: false
})
export class MessageBubbleComponent implements OnInit {
    @Input() message: ClubMessage;
    @Input() fromMe: boolean;
    @Input() showAvatar$: Observable<boolean>;

    userSubscription: Subscription;
    userData: IChatUserInfoData;

    constructor(
        private chatUserInfoDispatcher: ChatUserInfoDispatcher,
        private ref: ChangeDetectorRef,
    ) {}

    ngOnInit() {
        this.initSubscriptions();
    }

    initSubscriptions() {
        this.userSubscription = this.chatUserInfoDispatcher.getChatUserInfoObservable(this.message.senderID)
            .pipe(distinctUntilChanged())
            .subscribe(chatUserInfo => {
                this.userData = chatUserInfo;
                this.ref.detectChanges();
            });
    }

    getAvatarUrl(showAvatars: boolean): string {
        if (!showAvatars) return 'assets/icon/thumbnail.png';
        if (this.userData.useNftAsAvatar) {
            if(this.userData.usingCroppedImage) {
                if (this.userData.croppedImageUrl) return this.userData.croppedImageUrl;
                return 'assets/img/cropped_nft_loader.gif';
            }
            return this.userData.nftUrl;
        } else return GameSettingsService.getAvatarUrl(this.userData.photoUrl);
    }

    onImageError(event: any, size?: BrockenImageSize, type?: ImageType) {
        event.target.src = GameSettingsService.getSopoBrokenImageUrl(
            size,
            type
        );
    }

    ngOnDestroy(): void {
        if (this.userSubscription) this.userSubscription.unsubscribe();
    }
}
